
(function () {
  var path = window.location.pathname;

  var key = 'boost-collection-return-product';
  var highlightClass = 'collection-return-highlight';

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  if (!document.getElementById('collection-return-highlight-style')) {
    var style = document.createElement('style');
    style.id = 'collection-return-highlight-style';
    style.textContent =
      '.' + highlightClass + ' {' +
      'border: solid #6b8fff80 2px !important;' +
      'box-sizing: border-box;' +
      '}';
    document.head.appendChild(style);
  }

  function getProductHandle(url) {
    var productPath = new URL(url, window.location.origin).pathname;
    var parts = productPath.split('/products/');
    if (!parts[1]) return '';
    return parts[1].split('/')[0].split('?')[0];
  }

  function saveReturnProduct(event) {
    var productLink = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!productLink) return;

    var handle = getProductHandle(productLink.href);
    if (!handle) return;

    sessionStorage.setItem(key, JSON.stringify({
      restore: true,
      productHandle: handle,
      time: Date.now()
    }));

    console.log('[collection restore] saved product', handle);
  }

  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, saveReturnProduct, true);
  });

  function highlightProduct(productLink) {
    var productCard = productLink.closest('li') || productLink;

    productCard.classList.add(highlightClass);

    setTimeout(function () {
      productCard.classList.remove(highlightClass);
    }, 3200);
  }

  function restoreToProduct(saved) {
    var maxWait = 8000;
    var timeoutId;
    var observer;

    function findAndRestore() {
      var productLink = document.querySelector('a[href*="/products/' + saved.productHandle + '"]');

      if (!productLink) return false;

      productLink.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });

      highlightProduct(productLink);

      sessionStorage.removeItem(key);
      console.log('[collection restore] smooth restored product', saved.productHandle);

      if (observer) observer.disconnect();
      if (timeoutId) clearTimeout(timeoutId);

      return true;
    }

    if (findAndRestore()) return;

    observer = new MutationObserver(function () {
      findAndRestore();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    timeoutId = setTimeout(function () {
      if (observer) observer.disconnect();
      sessionStorage.removeItem(key);
      console.log('[collection restore] product not found', saved.productHandle);
    }, maxWait);
  }

  function checkRestore() {
    var savedRaw = sessionStorage.getItem(key);
    if (!savedRaw) return;

    var saved;
    try {
      saved = JSON.parse(savedRaw);
    } catch (e) {
      return;
    }

    if (!saved.restore || !saved.productHandle) return;

    console.log('[collection restore] waiting for product', saved.productHandle);
    restoreToProduct(saved);
  }

  window.addEventListener('pageshow', checkRestore);
  window.addEventListener('load', checkRestore);
})();